export const SPEECH_RECOGNITION_MESSAGES = {
  ERROR: '<speech recognition error>',
  NO_RESPONSE: '<no response recognized>',
} as const;
